import { PageHero } from "@/components/Bits";
import { Reveal } from "@/components/Reveal";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { COMPANY, IMAGES } from "@/lib/data";

export default function ReachUs() {
  const actions = [
    { icon: Phone, label: "Call Us", value: COMPANY.phone, href: `tel:${COMPANY.phoneRaw}`, testid: "reach-call" },
    { icon: MessageCircle, label: "WhatsApp Us", value: "Chat on WhatsApp", href: `https://wa.me/${COMPANY.whatsapp}`, testid: "reach-whatsapp" },
    { icon: Mail, label: "Email Us", value: COMPANY.email, href: `mailto:${COMPANY.email}`, testid: "reach-email" },
  ];

  return (
    <div>
      <PageHero index="07 — Reach Us" title={<>Let's Talk<br />Manufacturing.</>} subtitle="Get in touch with our team for quotations, technical discussions and partnerships." image={IMAGES.factoryWide} />

      <section className="max-w-[1500px] mx-auto px-5 md:px-10 py-24 md:py-32 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <div className="grid gap-4">
            {actions.map((a, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <a href={a.href} target={a.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid={a.testid} className="group flex items-center justify-between border border-[#DCE1E8] bg-white p-6 hover:border-[#1D4ED8] hover:bg-[#F4F6F9] transition-colors duration-300">
                  <div className="flex items-center gap-4">
                    <a.icon size={22} className="text-[#1D4ED8]" />
                    <div>
                      <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{a.label}</div>
                      <div className="font-display font-bold text-lg tracking-tight text-[#0E1626]">{a.value}</div>
                    </div>
                  </div>
                  <ArrowUpRight size={18} className="text-slate-400 group-hover:text-[#1D4ED8] transition-colors duration-300" />
                </a>
              </Reveal>
            ))}
            <Reveal delay={0.2}>
              <Link to="/enquiry" data-testid="reach-request-quote" className="btn-primary justify-center mt-2">Request A Quote <ArrowUpRight size={16} /></Link>
            </Reveal>
          </div>

          <Reveal delay={0.25}>
            <div className="mt-8 border border-[#DCE1E8] bg-white p-6 space-y-5">
              <div className="flex items-start gap-4">
                <MapPin size={20} className="text-[#1D4ED8] mt-1 shrink-0" />
                <div><div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mb-1">Office Address</div><div className="text-slate-700 font-light">{COMPANY.address}</div></div>
              </div>
              <div className="flex items-start gap-4">
                <Clock size={20} className="text-[#1D4ED8] mt-1 shrink-0" />
                <div><div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mb-1">Business Hours</div><div className="text-slate-700 font-light">{COMPANY.hours}<br />Sunday: Closed</div></div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <div className="border border-[#DCE1E8] overflow-hidden h-full min-h-[460px]">
              <iframe
                title="JM Mevada location"
                data-testid="google-map"
                src="https://www.google.com/maps?q=Shiv%20Bhumi%20Industrial%20Park%20Bakrol%20Bujrang%20Ahmedabad%20382433&output=embed"
                className="w-full h-full min-h-[460px]"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
